import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> API Security Testing</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>API Security Testing</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  APIs (Application Programming Interfaces) have become the
                  backbone of modern digital ecosystems, enabling seamless
                  integration between applications, mobile apps, cloud services,
                  and third-party platforms. While APIs accelerate innovation,
                  they also expand the attack surface, making them a prime
                  target for cybercriminals. API Security Testing ensures that
                  your APIs are secure, resilient, and protected against
                  vulnerabilities that could expose sensitive data or disrupt
                  business-critical operations
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-arrows-down-to-people"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>High-Risk Exposure</h3>
                    <p> 
                      APIs directly connect applications and databases — making
                      them a common entry point for attackers.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-database"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Data Protection</h3>
                    <p>
                      Sensitive customer, financial, and operational data often
                      flows through APIs, requiring strong safeguards.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-shield-halved"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Compliance Requirements</h3>
                    <p>
                      Regulatory frameworks such as GDPR, HIPAA, PCI DSS, and
                      ISO 27001 demand secure handling of data shared via APIs.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-table"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Growing API Usage</h3>
                    <p>
                      As businesses scale digital services, the number of
                      exposed APIs increases — multiplying security risks.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-business-time"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Real-World Breaches</h3>
                    <p>
                      Many high-profile security breaches originated from poorly
                      secured APIs.
                    </p>
                  </div>
                </div>
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "methodology" ? " active" : ""}`}
                        onClick={() => setActiveTab("methodology")}
                      >
                        Methodology
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "keybenefits" ? " active" : ""}`}
                        onClick={() => setActiveTab("keybenefits")}
                      >
                        Key Benefits
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "deliverables" ? " active" : ""}`}
                        onClick={() => setActiveTab("deliverables")}
                      >
                        Deliverables
                      </button>
                    </li>
                  </ul>

                  {/* Pills content */}
                  <div className="tab-content" id="ex2-content">
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      id="methodology"
                      role="tabpanel"
                      aria-labelledby="ex3-tab-1"
                    >
                      <p>
                        Our API Security Testing process blends manual expertise
                        and automated tools for comprehensive coverage:
                      </p>
                      <ul>
                        <li>
                          <b>Discovery & Mapping :-</b> Identify and document
                          all exposed APIs (REST, SOAP, GraphQL, WebSocket,
                          etc.).
                        </li>
                        <li>
                          <b>Authentication & Authorization Testing :-</b>{" "}
                          Validate token-based auth, OAuth, API keys, and
                          role-based access controls.
                        </li>
                        <li>
                          <b>Input & Payload Manipulation :-</b> Assess
                          vulnerabilities such as injection, parameter
                          tampering, and mass assignment.
                        </li>
                        <li>
                          <b>Business Logic Testing :-</b> Detect logic flaws
                          that could bypass workflows or expose data.
                        </li>
                        <li>
                          <b>OWASP API Security Top 10 :-</b> Benchmark
                          vulnerabilities against industry standards.
                        </li>
                        <li>
                          <b>Rate Limiting & DoS Testing :-</b> Validate
                          resilience against denial-of-service or brute-force
                          attempts.
                        </li>
                        <li>
                          <b>Data Validation & Encryption Review :-</b> Ensure
                          secure data transmission and storage practices.
                        </li>
                      </ul>
                    </div>
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      id="keybenefits"
                      role="tabpanel"
                      aria-labelledby="ex3-tab-2"
                    >
                      <ul>
                        <li>
                          Prevent data breaches by eliminating API-level
                          vulnerabilities.
                        </li>
                        <li>
                          Strengthen trust with customers and partners by
                          ensuring secure integrations.
                        </li>
                        <li>
                          Ensure compliance with regulatory and industry
                          standards.
                        </li>
                        <li>
                          Improve resilience against automated and large-scale
                          API attacks.
                        </li>
                        <li>
                          Gain full visibility into your API security posture.
                        </li>
                      </ul>
                    </div>
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      id="deliverables"
                      role="tabpanel"
                      aria-labelledby="ex3-tab-3"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>
                          <b>Detailed Security Assessment Report :-</b> Listing
                          vulnerabilities with severity levels and impact
                          analysis.
                        </li>
                        <li>
                          <b>Technical Remediation Guidance :-</b>{" "}
                          Developer-friendly recommendations for secure coding
                          and fixes.
                        </li>
                        <li>
                          <b>Risk-Based Prioritization :-</b> Clear action plan
                          based on exploitability and business impact.
                        </li>
                        <li>
                          <b>Compliance Mapping :-</b> – Evidence aligned with
                          OWASP API Top 10 and regulatory standards.
                        </li>
                        <li>
                          <b>Executive Summary :-</b> Non-technical insights for
                          leadership decision-making.
                        </li>
                        <li>
                          <b>Validation Testing (Optional) :-</b> Re-testing
                          after fixes to confirm vulnerabilities are resolved.
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* Pills content */}
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <p>
                    We don’t just test APIs — we secure your digital backbone.
                    Here’s why clients trust us:
                  </p>
                  <ul>
                    <li>
                      <b>Specialized Expertise :-</b> Our team is trained on
                      OWASP API Top 10 and advanced API-specific attack vectors.
                    </li>
                    <li>
                      <b>End-to-End Coverage :-</b>We test both external and
                      internal APIs across web, mobile, and cloud platforms.
                    </li>
                    <li>
                      <b>Beyond Tools :-</b> Automated scans alone miss logic
                      flaws — our manual penetration testing ensures deeper
                      coverage.
                    </li>
                    <li>
                      <b>Business-Centric :-</b> We align testing with your
                      workflows and data sensitivity, not just generic
                      checklists.
                    </li>
                    <li>
                      <b>Cloud & Modern Tech Ready :-</b> Expertise in APIs for
                      microservices, serverless, and containerized environments.
                    </li>
                    <li>
                      <b>Remediation Support :-</b> : We provide actionable
                      guidance and work with your developers to close security
                      gaps.
                    </li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;